import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

// Email-only password reset flow. Step 1 → request code, step 2 → enter code + new password.
export default function Forgot() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPw, setNewPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const requestEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot", { email });
      toast.success("If that email exists, a code has been sent. (Check spam too.)");
      setStep(2);
    } catch {
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const reset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset", { email, code: code.trim().replace(/\s+/g, ""), new_password: newPw });
      toast.success("Password reset. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 460, margin: "80px auto", padding: "0 24px" }} data-testid="forgot-page">
      <div className="bg-card" style={{ padding: 36 }}>
        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 12 }}>RESET PASSWORD</div>
          <h1 className="serif" style={{ fontSize: 30, color: "#fff", margin: 0, fontWeight: 400 }}>
            {step === 1 ? "Forgot your password?" : "Enter your code"}
          </h1>
        </div>

        {step === 1 && (
          <form onSubmit={requestEmail} data-testid="forgot-email-form">
            <label className="label-dark">Email</label>
            <input data-testid="forgot-email" required type="email" value={email} onChange={e => setEmail(e.target.value)} className="input-dark" style={{ marginBottom: 20 }} placeholder="you@email.com" />
            <button data-testid="forgot-submit" type="submit" disabled={loading} className="btn-gold" style={{ width: "100%", padding: "14px" }}>
              {loading ? "Sending…" : "Email me a code"}
            </button>
            <div className="muted" style={{ fontSize: 11, marginTop: 12, lineHeight: 1.5 }}>
              You&apos;ll receive a 6-digit code by email within a minute. If you don&apos;t see it, check spam.
            </div>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={reset}>
            <label className="label-dark">6-digit code</label>
            <input data-testid="reset-code" required value={code} onChange={e => setCode(e.target.value)} className="input-dark" style={{ marginBottom: 16, letterSpacing: "0.4em", textAlign: "center", fontSize: 18 }} placeholder="000000" maxLength={6} inputMode="numeric" />
            <label className="label-dark">New password</label>
            <input data-testid="reset-new-password" required type="password" minLength={6} value={newPw} onChange={e => setNewPw(e.target.value)} className="input-dark" style={{ marginBottom: 20 }} placeholder="At least 6 characters" />
            <button data-testid="reset-submit" type="submit" disabled={loading} className="btn-gold" style={{ width: "100%", padding: "14px" }}>
              {loading ? "Resetting…" : "Reset Password"}
            </button>
            <button type="button" data-testid="reset-back" onClick={() => { setStep(1); setCode(""); setNewPw(""); }} className="btn-ghost" style={{ width: "100%", padding: "12px", marginTop: 10, fontSize: 13 }}>
              ← Use a different email
            </button>
          </form>
        )}

        <div style={{ marginTop: 22, textAlign: "center", fontSize: 14 }} className="muted">
          <Link to="/login" className="link-gold">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
